import { render, staticRenderFns } from "./ProjectRespondents.vue?vue&type=template&id=f459768c&scoped=true&"
import script from "./ProjectRespondents.vue?vue&type=script&lang=ts&"
export * from "./ProjectRespondents.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectRespondents.vue?vue&type=style&index=0&id=f459768c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f459768c",
  null
  
)

export default component.exports